import {

    MimaText,
    QuickLinksComponent as QLC,
    Modal,
    MimaButton,
    AppPage,
    PageLoader,
    Searchbar,
    MimaInput,
    MimaTagInput,
    MimaTextArea,
} from '../../components';
import styles from '../../assets/styles/BulkSms/BulkSms.module.scss';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { useMediaQuery } from 'react-responsive';
import { AnimatePresence } from 'framer-motion';
import React, { useState } from 'react';
import { IoIosCreate } from 'react-icons/io';
import { EditSmsContainer, NewSmsContainer, ScheduleMessageContainer } from '../../containers';
import { Formik } from 'formik';
import OtpInput from 'react-otp-input';
import { bulkSmsStore } from '../../stores';
import moment from 'moment';

const BulkSms = ({
    composeSide,
    showComposeSide,
    setMsgView,
    msgView,
    showScheduleMsgModal,
    schedule,
    closeModal,
    loading,
    customers,
    vendors,
    tags,
    setTags,
    setBtnClicked,
    btnClicked,
    otp,
    setOtp,
    onSubmitOtp,
    allMsgs,
    msgFilterItem,
    setMsgFilterItem,
    goToViewMsgs,
    sendDraft,
    refresh,
    loading2,
    editMessage,
    closeComposeSide,
    goToEditMessage,
    sendPayload,
    setSendPayload,
    openSendScheduledModal,
    sendScheduled,
    goBackFromViewMsgs,
}) => {
    const isBelow900 = useMediaQuery({
        query: '(max-width: 900px)',
    });

    const selectedMessage = bulkSmsStore.selectedMessage

    const allMsgsSplit = allMsgs.filter((x) => {
        return x.status === msgFilterItem
    })

    return (
        <AppPage pageTitle="Bulk Sms" refresh={refresh}>
            <div className={styles.super}>
                {loading2 ? (
                    <div className={styles.pageLoad}>
                        <PageLoader title="Loading messages" loading={loading2} />
                    </div>) : (
                    <>
                        {(!isBelow900 || !composeSide) && (
                            <div className={composeSide ? `${styles.main} ${styles.main__alt}` : styles.main}>
                                {msgView === "Single Message" ? (
                                    <div className={styles.singleMessage}>
                                        <div className={styles.beside}>

                                            <MimaButton
                                                variant="filter"
                                                title="Go Back"
                                                buttonColor="var(--color-error)"
                                                width={12}
                                                onClick={goBackFromViewMsgs}
                                                mb={2}
                                            />

                                            {selectedMessage.status === "SCHEDULED" || selectedMessage.status === "DRAFT" ? (
                                                <MimaButton
                                                    variant="filter"
                                                    title="Edit"
                                                    width={12}
                                                    onClick={() => { goToEditMessage(selectedMessage) }}
                                                    mb={2}
                                                />
                                            )
                                                : ""}

                                            {selectedMessage.status === "DRAFT" ? (
                                                <MimaButton
                                                    variant="filter"
                                                    title="Send Draft"
                                                    buttonColor="var(--color-primary)"
                                                    width={14}
                                                    onClick={() => { sendDraft(selectedMessage._id) }}
                                                    mb={2}
                                                />
                                            )
                                                : ""}

                                            {selectedMessage.status === "SCHEDULED" ? (
                                                <MimaButton
                                                    variant="filter"
                                                    title="Send Now"
                                                    buttonColor="var(--color-primary)"
                                                    width={18}
                                                    onClick={() => { openSendScheduledModal(selectedMessage._id) }}
                                                    mb={2}
                                                />
                                            )
                                                : ""}
                                        </div>

                                        <MimaText variant="smallBold" labelTitle="Sent To" mb={2}>{selectedMessage.numbersAndNames}</MimaText>
                                        <div className={styles.beside}>
                                            <MimaText variant="smallBold" labelTitle="Message created on" mb={2}>
                                                {moment(selectedMessage.createdAt).format('DD/MM/YYYY')}
                                            </MimaText>
                                            <MimaText variant="smallBold" labelTitle="Message status" mb={2}>
                                                {selectedMessage.status}
                                            </MimaText>
                                            {selectedMessage.status === "SCHEDULED" ? (
                                                <MimaText variant="smallBold" labelTitle="Scheduled for" mb={2}>
                                                    {moment(selectedMessage.scheduledTime).format("DD/MM/YY HH:mm A")}
                                                </MimaText>
                                            ) : ""}
                                        </div>
                                        <MimaText labelTitle="Full message text">
                                            {selectedMessage.message}
                                        </MimaText>
                                        <div className={styles.main__content__line}></div>
                                    </div>) : (
                                    <>
                                        <div className={styles.main__nav}>
                                            <div className={styles.main__nav__actions}>
                                                <div
                                                    className={msgView === "Sent Messages" ? styles.main__nav__actions__active : ""}
                                                    onClick={() => {
                                                        setMsgView("Sent Messages")
                                                        setMsgFilterItem("SENT")
                                                    }} >
                                                    Sent Messages
                                                </div>
                                                <div
                                                    className={msgView === "Scheduled Messages" ? styles.main__nav__actions__active : ""}
                                                    onClick={() => {
                                                        setMsgView("Scheduled Messages")
                                                        setMsgFilterItem("SCHEDULED")
                                                    }}>
                                                    Scheduled Messages
                                                </div>
                                                <div
                                                    className={msgView === "Drafts" ? styles.main__nav__actions__active : ""}
                                                    onClick={() => {
                                                        setMsgView("Drafts")
                                                        setMsgFilterItem("DRAFT")
                                                    }}>
                                                    Drafts
                                                </div>
                                            </div>
                                            {!composeSide && (
                                                <div className={styles.main__nav__compose} onClick={showComposeSide}>
                                                    <IoIosCreate /> <span>Compose</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className={styles.main__content}>
                                            {
                                                allMsgsSplit.length === 0 ? (
                                                    <>
                                                        <MimaText align="center" variant="subtitleBold">
                                                            No {msgFilterItem} message(s) yet
                                                        </MimaText>
                                                    </>) : (<>
                                                        {allMsgsSplit.map((msg, i) => (
                                                            <div key={i}>

                                                                <>
                                                                    <div className={styles.main__content__cover}>
                                                                        <div>
                                                                            <MimaText variant="smallBold">To: {msg.truncatedNumbers}</MimaText>
                                                                            <MimaText>
                                                                                {msg.truncatedMsg}
                                                                            </MimaText>
                                                                        </div>
                                                                        <div>
                                                                            <MimaText variant="small" align="center" mb={0.5}>
                                                                                {moment(msg.createdAt).format('DD/MM/YYYY')}
                                                                            </MimaText>
                                                                            <MimaButton variant="filter" title="View" width={8} onClick={() => { goToViewMsgs(msg) }} />
                                                                        </div>
                                                                    </div>
                                                                    <div className={styles.main__content__line}></div>
                                                                </>


                                                            </div>
                                                        ))}
                                                    </>
                                                )
                                            }

                                        </div>
                                    </>)}
                            </div>
                        )}
                    </>
                )}
                {composeSide && (loading ? (
                    <div className={styles.pageLoad}>
                        <PageLoader loading={loading} />
                    </div>) : (
                    editMessage ? (
                        <EditSmsContainer
                            closeComposeSide={closeComposeSide}
                            tags={tags}
                            setTags={setTags}
                            customers={customers}
                            vendors={vendors}
                            btnClicked={btnClicked}
                            sendPayload={sendPayload}
                            setSendPayload={setSendPayload}
                            showComposeSide={showComposeSide}
                            setBtnClicked={setBtnClicked}
                            showScheduleMsgModal={showScheduleMsgModal}
                            setMsgView={setMsgView}
                            setMsgFilterItem={setMsgFilterItem}
                        />
                    ) : (
                        <NewSmsContainer
                            closeComposeSide={closeComposeSide}
                            tags={tags}
                            setTags={setTags}
                            customers={customers}
                            vendors={vendors}
                            btnClicked={btnClicked}
                            sendPayload={sendPayload}
                            setSendPayload={setSendPayload}
                            showComposeSide={showComposeSide}
                            setBtnClicked={setBtnClicked}
                            showScheduleMsgModal={showScheduleMsgModal}
                            setMsgView={setMsgView}
                            setMsgFilterItem={setMsgFilterItem}
                        />
                    )
                ))}
            </div>

            {(schedule ||
                btnClicked === "send" ||
                btnClicked === "sendDraft" ||
                btnClicked === "sendScheduled" ||
                btnClicked === "scheduleMessageEdit") && (
                    <div className='modal'>
                        <AnimatePresence>
                            {(schedule || btnClicked === "scheduleMessageEdit") && (
                                <ScheduleMessageContainer
                                    closeModal={closeModal}
                                    sendPayload={sendPayload}
                                    closeComposeSide={closeComposeSide}
                                    tags={tags}
                                    setTags={setTags}
                                    showComposeSide={showComposeSide}
                                    btnClicked={btnClicked}
                                    setMsgView={setMsgView}
                                    setMsgFilterItem={setMsgFilterItem}
                                />
                            )}
                            {(btnClicked === "send" || btnClicked === "sendDraft") && (
                                <Modal closeModal={closeModal}>
                                    <Formik
                                        initialValues={{
                                            otp: '',
                                        }}
                                        onSubmit={onSubmitOtp}>
                                        {({ handleChange, handleBlur, values, errors, touched }) => (
                                            <form>
                                                {loading ? (
                                                    <PageLoader
                                                        title="Sending Your Message(s)...."
                                                        loading={loading}
                                                    />
                                                ) : (
                                                    <div className={styles.centerContent}>

                                                        <MimaText align="center" mb={2} variant="bodyBold" color="var(--color-primary)">
                                                            Enter your pin to send message
                                                        </MimaText>

                                                        <div className={styles.pin__group}>
                                                            <MimaText ml={2} mb={0.5}>Enter Pin</MimaText>
                                                            <div className={styles.otp__group}>
                                                                <OtpInput
                                                                    value={otp}
                                                                    onChange={otp => {
                                                                        setOtp(otp);
                                                                        if (otp >= 1000) {
                                                                            onSubmitOtp(otp);
                                                                        }
                                                                    }}
                                                                    numInputs={4}
                                                                    isInputSecure={true}
                                                                    inputStyle={{
                                                                        fontSize: '2.4rem',
                                                                        fontFamily: 'inherit',
                                                                        width: '6rem',
                                                                        height: '6rem',
                                                                        margin: '.4rem',
                                                                        borderTop: '0px',
                                                                        border: '1px solid #4A4A68',
                                                                        borderRadius: '1rem',
                                                                        display: 'block',
                                                                        outline: 'none',
                                                                        textAlign: 'center',
                                                                        marginRight: '2rem',
                                                                    }}
                                                                    isInputNum
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </form>
                                        )}
                                    </Formik>
                                </Modal>

                            )}

                            {(btnClicked === "sendScheduled") && (
                                <Modal closeModal={closeModal}>
                                    {loading ? (
                                        <PageLoader
                                            title="Sending Your Message(s)...."
                                            loading={loading}
                                        />
                                    ) : (
                                        <>
                                            <MimaText width={38} align="center" mb={2} variant="subtitleBold" color="var(--color-primary)">
                                                Override Schedule
                                            </MimaText>
                                            <MimaText width={38} align="center" mb={4} >
                                                Are you sure you want to over ride Scheduled time and send this message now?
                                            </MimaText>
                                            <div className={styles.beside}>
                                                <MimaButton
                                                    title="Yes"
                                                    width={18}
                                                    onClick={sendScheduled} />
                                                <MimaButton
                                                    title="No, cancel"
                                                    width={18}
                                                    buttonColor="var(--color-dark)"
                                                    onClick={closeModal}
                                                />
                                            </div>

                                        </>
                                    )}
                                </Modal>
                            )}

                        </AnimatePresence>
                    </div>
                )}
        </AppPage>
    );
};

export default BulkSms;
